// extracted by mini-css-extract-plugin
module.exports = {"ratingNumber":"az_VKc","ratingReviews":"az_WKc","ratingsContainer":"az_XKc"};